import React,{useEffect, useState} from "react";
import { useMsal } from "@azure/msal-react";
import Loader from '../component/Loader/Loader';
import { InteractionStatus } from "@azure/msal-browser";
import { loginRequest } from "../msalConfig";
import { useLocation,Navigate  } from "react-router-dom";

export const ProtectedRoute = ({children}) => {
    const location = useLocation();
    //const isAuthenticated          = useIsAuthenticated();
    const { instance, inProgress } = useMsal();
    const [isAuthenticated,setIsAuthenticated] = useState(false);
    const accounts = instance.getAllAccounts();

    useEffect(() => {
        const checkToken = async () => {
            const account = instance.getAllAccounts();
            if(!account.length){
                instance.loginRedirect(loginRequest);
                return;
            }
            const request = {
                ...loginRequest,
                account: account[0]
            };
            try {
                await instance.acquireTokenSilent(request);
                if ( !accounts[0]?.idTokenClaims?.groups.includes('5d31827a-295c-4455-9add-2f9d6c073d7f') && !accounts[0]?.idTokenClaims?.groups.includes('bc07e057-b44f-40df-ba4f-251acff402e8')) {
                    alert('Access Denied');
                    instance.logoutRedirect({
                        postLogoutRedirectUri: "/",
                    });
                    return;
                }
                setIsAuthenticated(true);
            } catch (error) {
                instance.loginRedirect(loginRequest);
            }
        }

        if (!isAuthenticated && inProgress === InteractionStatus.None) {
            // instance.loginRedirect(loginRequest).catch((error) => {
            //     console.log('error is', error)
            // })
            //instance.loginRedirect(loginRequest);
            checkToken();
            return;
        }
        
        //checkToken();
      }, [isAuthenticated,instance,inProgress]);

    if (!isAuthenticated) {
        return (<Loader />);
    }

    if((location.pathname === '/settings' || location.pathname === '/mapping/upload' || location.pathname === '/mapping/download') && !accounts[0]?.idTokenClaims?.groups.includes("bc07e057-b44f-40df-ba4f-251acff402e8")){
        return <Navigate to="/access-denied" />
    } 

    return children;
} 